import { Trans } from 'react-i18next';

import { ModalDialog } from './ModalDialog';

export interface ArchiveConfirmDialogProps {
	resourceType: string;
	resourceName: string;
	onCancel: () => void;
	onConfirm: () => void;
	show: boolean;
}
export function ArchiveConfirmDialog({
	resourceName,
	resourceType,
	onCancel,
	onConfirm,
	show,
}: ArchiveConfirmDialogProps) {
	return (
		<ModalDialog
			show={show}
			type="archive"
			onCancel={onCancel}
			headerContent={
				<Trans
					ns="common"
					i18nKey="modal.confirmArchiveWithType"
					values={{ resourceType }}
				/>
			}
			bodyContent={
				<Trans
					ns="common"
					i18nKey="modal.confirmArchiveBody"
					values={{ resourceName }}
				/>
			}
			onConfirm={onConfirm}
		/>
	);
}
